import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NotificationItemProps } from "apis/notification";
import { PaginationProps } from "utils/types/API";

export interface NotificationState {
    loading: boolean;
    list: {
        data: NotificationItemProps[];
        options: NotificationItemProps[];
        pagination?: PaginationProps;
    };
    item: {
        data?: NotificationItemProps;
    };
}

const initialState: NotificationState = {
    loading: false,
    list: {
        data: [],
        options: []
    },
    item: {
    }
};

interface IndexProps {
    data: NotificationItemProps[];
    pagination?: PaginationProps;
}
interface ItemProps {
    data?: NotificationItemProps;
}
export const notificationSlice = createSlice({
    name: "notification",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;
        },
        options: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.options = action.payload.data;
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
    },
});

export const { loading, endLoading, index, options, find, create, update } = notificationSlice.actions;
export default notificationSlice.reducer;
